import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10a53184"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "add-tag-doropdown-options-wrap shadow-deep has-background-modest",
  ref: "addTagDropdownOption"
}
const _hoisted_2 = { class: "add-tag-doropdown-option new-tag" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "modal-window--title" }
const _hoisted_5 = { class: "modal-window--footer" }
const _hoisted_6 = { class: "modal-window--footer__input-wrap" }
const _hoisted_7 = { class: "modal-window--footer__input-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_AppTagAddition = _resolveComponent("AppTagAddition")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ui = _resolveComponent("ui")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "add-tag-doropdown",
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onShowAddTagOption && _ctx.onShowAddTagOption(...args)))
    }, [
      (_ctx.styled==='is-default')
        ? (_openBlock(), _createBlock(_component_ButtonIcon, {
            key: 0,
            onClick: _ctx.onShowAddTagOption,
            onKeydown: _withKeys(_withModifiers(_ctx.onShowAddTagOption, ["prevent"]), ["space","enter"]),
            iconAfter: "plus-circle",
            iconAfterSize: "is-small",
            class: "button-add-tag",
            styled: "is-none",
            "aria-label": _ctx.$t('mycollection.bookmarkAdd')
          }, null, 8, ["onClick", "onKeydown", "aria-label"]))
        : (_openBlock(), _createBlock(_component_AppButton, {
            key: 1,
            onClick: _ctx.onShowAddTagOption,
            onKeydown: _withKeys(_withModifiers(_ctx.onShowAddTagOption, ["prevent"]), ["space","enter"]),
            styled: "is-none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppTagAddition, {
                text: _ctx.$t('mycollection.bookmarkAdd'),
                addition: true,
                class: "add-tag-doropdown-button"
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown"])),
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ui, { class: "add-tag-doropdown-options" }, {
          default: _withCtx(() => [
            _createElementVNode("li", _hoisted_2, [
              _createVNode(_component_AppButton, {
                class: "add-tag-doropdown-button option",
                onClick: _ctx.onShowModalNewTagName,
                onKeydown: _withKeys(_withModifiers(_ctx.onShowModalNewTagName, ["prevent"]), ["space","enter"]),
                disabled: _ctx.tagList.length >= 51
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('mycollection.collectionNew')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "onKeydown", "disabled"])
            ]),
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, (tag, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (tag.id !== 0 && tag.id !== 99999)
                  ? (_openBlock(), _createElementBlock("li", {
                      class: "add-tag-doropdown-option add-tag",
                      key: `tag-doropdown-${_ctx.pid}-${tag.id}-${index}`
                    }, [
                      _createVNode(_component_AppButton, {
                        class: _normalizeClass(["add-tag-doropdown-button option", tag.isActive ? 'active' : '']),
                        onClick: ($event: any) => (tag.isActive ? _ctx.onUnlink(tag.id) : _ctx.onLink(tag.id)),
                        onKeydown: _withKeys(_withModifiers(($event: any) => (tag.isActive ? _ctx.onUnlink(tag.id) : _ctx.onLink(tag.id)), ["prevent"]), ["space","enter"])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick", "onKeydown"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _ctx.isShowAddTagOption]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "screen-over",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowAddTagOption && _ctx.onShowAddTagOption(...args))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onShowAddTagOption && _ctx.onShowAddTagOption(...args)), ["prevent"]), ["space","enter"]))
      }, null, 544), [
        [_vShow, _ctx.isShowAddTagOption]
      ])
    ], 32),
    (_ctx.isShowModalNewTag)
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 0,
          onClose: _ctx.onCloseModalNewTagName,
          heading: _ctx.$t('mycollection.collectionNew'),
          class: "modal-window modal-width"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('mycollection.collectionsTitle')), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_AppInput, {
                modelValue: _ctx.state.newTagName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.newTagName) = $event)),
                placeholder: _ctx.$t('mycollection.collectionsTitle') + '...',
                inputId: 'newTagName-input',
                class: "mycollection-new-tag-name-input",
                "aria-label": _ctx.$t('mycollection.collectionNewToAdd')
              }, null, 8, ["modelValue", "placeholder", "aria-label"])
            ]),
            _createElementVNode("footer", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_AppButton, {
                  onClick: _ctx.onCloseModalNewTagName,
                  onKeydown: _withKeys(_withModifiers(_ctx.onCloseModalNewTagName, ["prevent"]), ["space","enter"]),
                  buttonId: 'button-cancel'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "onKeydown"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_AppButton, {
                  onClick: _ctx.onEntry,
                  onKeydown: _withKeys(_withModifiers(_ctx.onEntry, ["prevent"]), ["space","enter"]),
                  class: _normalizeClass('is-accent'),
                  disabled: _ctx.checkDisabledButtonEntry(_ctx.state.newTagName),
                  buttonId: 'button-apply-insert'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.create')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "onKeydown", "disabled"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose", "heading"]))
      : _createCommentVNode("", true)
  ], 64))
}